import { render, staticRenderFns } from "./organization-type.vue?vue&type=template&id=6b4590f0&"
import script from "./organization-type.vue?vue&type=script&lang=ts&"
export * from "./organization-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports